export default "__VITE_ASSET__BazOQ36C__"